// Mobile menu: auto-close sibling details
document.addEventListener('click', function (e) {
  if (window.innerWidth > 768) return;
  const summary = e.target.closest('.menu-opening summary');
  if (!summary) return;
  const currentDetails = summary.parentElement;
  document.querySelectorAll('.menu-opening details').forEach(function (details) {
    if (details !== currentDetails) details.removeAttribute('open');
  });
});

// Bundle quantity +/- buttons
document.addEventListener('click', function (e) {
  var plus = e.target.closest('.qty-btn.plus');
  var minus = e.target.closest('.qty-btn.minus');
  if (!plus && !minus) return;
  var wrapper = e.target.closest('.bundle-qty');
  if (!wrapper) return;
  var qtyInput = wrapper.querySelector('.bundle-qty-input');
  var value = parseInt(qtyInput.value) || 1;
  if (plus) value++;
  if (minus && value > 1) value--;
  qtyInput.value = value;
});

// Bundle add to cart
document.addEventListener('DOMContentLoaded', function () {
  var productForm = document.querySelector('product-form form');
  if (!productForm) return;
  var isSubmitting = false;
  productForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (isSubmitting) return;
    isSubmitting = true;
    var items = [];
    productForm.querySelectorAll('.bundle-card').forEach(function (card) {
      var checkbox = card.querySelector('.bundle-checkbox');
      var qtyInput = card.querySelector('.bundle-qty-input');
      if (checkbox && checkbox.checked && !checkbox.disabled) {
        items.push({ id: checkbox.dataset.variantId, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 });
      }
    });
    if (!items.length) { isSubmitting = false; return; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed');
      productForm.querySelectorAll('.bundle-qty-input').forEach(function (i) { i.value = 1; });
      productForm.querySelectorAll('.bundle-checkbox').forEach(function (c) { c.checked = false; });
      window.location.href = '/cart';
    }).catch(function (err) {
      console.error('Bundle add error:', err);
      isSubmitting = false;
    });
  });
});

// Buy Now button
document.addEventListener('DOMContentLoaded', function () {
  var productForm = document.querySelector('product-form form');
  var buyNowBtn = document.querySelector('.custom-buy-now-btn');
  if (!productForm || !buyNowBtn) return;
  buyNowBtn.addEventListener('click', function () {
    var items = [];
    var variantInput = productForm.querySelector('input[name="id"]');
    var qtyInput = productForm.querySelector('input[name="quantity"]');
    if (variantInput && variantInput.value) {
      items.push({ id: variantInput.value, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 });
    }
    productForm.querySelectorAll('.bundle-card').forEach(function (card) {
      var checkbox = card.querySelector('.bundle-checkbox');
      var qtyInput = card.querySelector('.bundle-qty-input');
      if (checkbox && checkbox.checked && !checkbox.disabled) {
        items.push({ id: checkbox.dataset.variantId, quantity: parseInt(qtyInput && qtyInput.value, 10) || 1 });
      }
    });
    if (!items.length) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('Buy Now failed');
      window.location.href = '/checkout';
    }).catch(function (err) { console.error('Buy Now error:', err); });
  });
});

// FAQ accordion toggle
document.addEventListener('DOMContentLoaded', function () {
  var faqContainers = document.querySelectorAll('.foteric-faq');
  if (!faqContainers.length) return;
  faqContainers.forEach(function (container) {
    var items = container.querySelectorAll('.faq-item');
    items.forEach(function (item) {
      var question = item.querySelector('.faq-question');
      var icon = item.querySelector('.faq-icon');
      if (!question) return;
      question.addEventListener('click', function () {
        items.forEach(function (i) {
          if (i !== item) {
            i.classList.remove('active');
            var otherIcon = i.querySelector('.faq-icon');
            if (otherIcon) otherIcon.textContent = '+';
          }
        });
        item.classList.toggle('active');
        if (icon) icon.textContent = item.classList.contains('active') ? '−' : '+';
      });
    });
  });
});
